import 'temporal-polyfill';
import { type DataRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ClockProvider } from '@/contexts/ClockContext';
import { LocaleProvider } from '@/contexts/LocaleContext';
import type { ClockType } from '@/models/common/clock.ts';
import { initialLocale } from '@/models/common/locale.ts';

interface AppProps {
  clock: ClockType;
  router: DataRouter;
}

export default function App({ clock, router }: Readonly<AppProps>) {
  return (
    <LocaleProvider locale={navigator.language ?? initialLocale}>
      <ClockProvider clock={clock}>
        <RouterProvider router={router} />
        <Toaster />
      </ClockProvider>
    </LocaleProvider>
  );
}
